<script setup lang="ts">
import DropdownMenuItemContent from "~/components/dumb/DropdownMenuItemContent.vue";
import { RecommendWithAiIcon } from "~/icons";
import { UserRole } from "~/shared/enums";
import { usePageStore, useUserStore } from "~/stores";

const emit = defineEmits<{
  recommend: [];
}>();

const props = defineProps<{
  close?: () => void;
}>();

const pageStore = usePageStore();
const userStore = useUserStore();

const onRecommend = () => {
  emit("recommend");
  props.close?.();
};
</script>

<template>
  <div
    v-if="pageStore.isOnline && userStore.isRoleGte(UserRole.MEMBER)"
    class="w-full border-t border-md md:rounded-b md:border-x md:border-t-0 md:border-b md:bg-lt md:py-1 md:app-drag-none">
    <DropdownMenuItemContent
      class="cursor-pointer text-base text-md select-none md:bg-lt md:text-sm md:hover:bg-md"
      :icon="RecommendWithAiIcon"
      :icon-args="{ class: 'icon-sm text-recommendation-base dark:text-recommendation-base' }"
      title="Fill out with AI"
      @click="onRecommend" />
  </div>
</template>
